
<template>
  <div class="kay-data-table">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="row">
            <div class="col-md-12">
              <div class="card-header">
                <h4 class="card-title">新增上架店家 - {{portal.title}}</h4>
              </div>

              <div class="card-body">
                <!-- <router-link to="./gaa-users/new" type="success">
                  <n-button type="success">建立 GAA 管理員</n-button>
                </router-link>-->

                <div class="row">
                  <div class="col-md-12">
                    <el-row :gutter="20">
                      <el-col :xs="12" :md="3">
                        <router-link to="./shops" type="success">
                          <el-button type="warning" size="small">返回入口列表</el-button>
                        </router-link>
                      </el-col>
                      <el-col :xs="24" :md="6">
                        <el-input
                          v-model="filters[0].value"
                          size="small"
                          placeholder="搜尋店家批次操作"
                          prefix-icon="el-icon-search"
                        ></el-input>
                      </el-col>
                      <el-col :xs="24" :md="6">
                        <!-- <router-link to="./send-coupons/add-shops" type="success">
                          <el-button type="primary" size="small" plain>將選擇店家加入活動</el-button>
                        </router-link>-->
                        <el-button
                          type="danger"
                          @click.native="addSelectedShops()"
                          size="small"
                          :disabled="disableUpdate"
                        >將選擇的店家加入</el-button>
                      </el-col>
                      <div v-if="updateInfo === 'updating'" style="margin: 10px 0 0 0;">
                        設定中
                        <i class="el-icon-loading"></i>
                      </div>
                      <div
                        v-if="updateInfo === 'success'"
                        style="color:#00BA00; margin: 10px 0 0 0;"
                      >
                        新增店家成功，請返回店家列表查看
                        <i class="now-ui-icons ui-1_check"></i>
                      </div>
                      <div v-if="updateInfo === 'error'" style="color:#BA0000; margin: 10px 0 0 0;">
                        新增店家失敗
                        <i class="now-ui-icons ui-1_simple-remove"></i>
                      </div>
                    </el-row>

                    <div class="card-header">
                      <h5>選擇要加入的店家</h5>
                    </div>
                    <p>從店家列表勾選要參與活動的店家後，點擊「將選擇的店家加入活動」按鈕。</p>

                    <!-- <data-tables :data="data" :filters="filters" :action-col="actionCol"> -->
                    <data-tables :data="data" :filters="filters">
                      <el-table-column label="選擇" prop="id" sortable="custom">
                        <template slot-scope="scope">
                          <div class="checkbox-radios">
                            <checkbox
                              v-model="scope.row.selected"
                              class="pull-left"
                              name="subscribe"
                            ></checkbox>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        v-for="title in titles"
                        :prop="title.prop"
                        :label="title.label"
                        :key="title.prop"
                        sortable="custom"
                      ></el-table-column>
                    </data-tables>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
import { Checkbox, Radio } from "src/components/index";
import {
  TimeSelect,
  DatePicker,
  Tag,
  Input,
  Button,
  Select,
  Option
} from "element-ui";

export default {
  components: {
    [DatePicker.name]: DatePicker,
    Checkbox,
    Radio
  },
  data() {
    return {
      updateInfo: "none",
      disableUpdate: false,
      portal: {
        title: ''
      },
      startTime: "",
      endTime: "",
      data: [],
      titles: [
        {
          prop: "id",
          label: "NO."
        },
        {
          prop: "name",
          label: "名稱"
        },
        // {
        //   prop: "voucherQty",
        //   label: "優惠券數量"
        // },
        // {
        //   prop: "sentQty",
        //   label: "已發出"
        // },
        // {
        //   prop: "remainQty",
        //   label: "剩餘數"
        // },
        // {
        //   prop: "wifiotgBusinessId",
        //   label: "行銷商店ID"
        // }
        // {
        //   prop: "updatedAt",
        //   label: "加入時間"
        // }
      ],
      // actionCol: {
      //   label: "操作",
      //   props: {
      //     align: "center"
      //   },
      //   buttons: [
      //     {
      //       props: {
      //         type: "warning",
      //         size: "small",
      //         icon: "el-icon-setting"
      //       },
      //       label: "查看明細",
      //       handler: row => {
      //         console.log("the row is ", row);

      //         this.$router.push(`/send-coupons/${row.id}/detail`);
      //       }
      //     }
      //   ]
      // },
      filters: [
        {
          value: "",
          prop: ["name", "id"]
        },
        {
          value: []
        }
      ]
    };
  },
  methods: {
    handleClick(command) {
      this.$message(`click dropdown button ${command}`);
    },
    // formatCampaign() {
    //   let self = this;
    //   // 處理conditions
    //   for (let i = 0; i < self.portal.conditions.length; ++i) {
    //     switch (self.portal.conditions[i].name) {
    //       case "paymentCheck":
    //         self.conditions.paymentCheck = "Q";
    //         // this.portal.conditions[i] = {
    //         //   derivation: "{{IF(order.paymentTypes !== 'cash','Y','N')}}",
    //         //   eval: false
    //         // }
    //         break;
    //       case "shopNewCheck":
    //         self.conditions.shopNewCheck = "Y";
    //         break;
    //       case "amountCheck":
    //         self.conditions.amountCheck = "Y";
    //         self.conditions.minConsumption =
    //           self.portal.conditions[i].value || 0; // 另外拉出來做成參數比較好做
    //         break;
    //     }
    //   }
    //   // this.portal.conditions;
    //   this.startTime = moment.unix(self.portal.startTs).toISOString();
    //   // .format("YYYY-MM-DD HH:mm:ss Z");

    //   this.endTime = moment.unix(self.portal.endTs).toISOString();

    //   // .format("YYYY-MM-DD HH:mm:ss Z");
    //   return;
    // },
    getPortalDetail() {
      let self = this;
      return axios
        .get(
          `${process.env.VUE_APP_APIHOST}/gaa/portals/${this.$route.params.portalKey}`
        )
        .then(response => {
          this.portal = response.data || {};

          console.log(
            "the campaign group " + JSON.stringify(self.portal)
          );
          
          return response.data;
        });
    },
    getUnjoinedShops() {
      return axios
        .get(
          `${process.env.VUE_APP_APIHOST}/gaa/portals/${this.$route.params.portalKey}/unjoined`
        )
        .then(response => {
          this.data = response.data;
          // for (let a of this.data) {
          //   a.updatedAt = moment
          //     .unix(a.updatedTs)
          //     .format("YYYY-MM-DD HH:mm:ss Z");

          //   a.statusDisplay = a.status === "disabled" ? "否" : "是";
          // }
          return response.data;
        });
    },
    addSelectedShops() {
      // 要避免重複送出
      this.disableUpdate = true;
      this.updateInfo = "updating";
      let newJoinedShops = [];
      for (let i = 0; i < this.data.length; ++i) {
        if (this.data[i] && this.data[i].selected) {
          newJoinedShops.push(this.data[i].id);
        }
      }
      console.log("New Joined " + JSON.stringify(newJoinedShops));
      console.log("the name is " + this.portal.name);
      return axios
        .post(
          `${process.env.VUE_APP_APIHOST}/gaa/portals/${this.$route.params.portalKey}/shops`,
          {
            shopIds: newJoinedShops
          }
        )
        .then(response => {
          // this.data = response.data;
          if (response.data && response.data.failed) {
            this.updateInfo = "error";
            this.getUnjoinedShops();
            return;
          }
          // for (let a of this.data) {
          //   a.updatedAt = moment
          //     .unix(a.updatedTs)
          //     .format("YYYY-MM-DD HH:mm:ss Z");

          //   a.statusDisplay = a.status === "disabled" ? "否" : "是";
          // }
          this.updateInfo = "success";
          this.getUnjoinedShops();
          window.close();
          return response.data;
        })
        .catch(e => {
          this.updateInfo = "error";
          this.disableUpdate = false;
        });
    }
  },
  mounted() {
    this.getPortalDetail();
    this.getUnjoinedShops();
  }
};
</script>
<style scoped>
.kay-data-table .btn-base,
.el-select .el-input .el-input__inner,
.btn,
.navbar .navbar-nav > a.btn {
  margin: 0px !important;
}
.k-form-label {
  margin: 5px 0 0 0;
}
.k-form-group {
  margin: 10px 0 10px 0;
}
/* .k-input input { */
/* margin: 10px; */
/* width: 100px; */
/* height: 30px; */
/* } */
</style>